import BenefitsContent from '../components/Communications/Contents/Benefits';
import MigrationContent from '../components/Communications/Contents/Migration';
import PrestationWithCode from '../components/Communications/Contents/PrestationWithCode';

export const types = {
  DAYS_VALIDATION: 'DAYS_VALIDATION',
  BOOLEAN_VALIDATION: 'BOOLEAN_VALIDATION',
  UNNAUTHENTICATE_VALIDATION: 'UNNAUTHENTICATE_VALIDATION',
};

// Communication
// id: number,
// title: string,
// children: Component,
// paths: string[] | null,
// acceptCircle: boolean,
// variable?: string,
// fromDate?: string, // format DD-MM-YYYY
// toDate?: string, // format DD-MM-YYYY
// each?: number,  // days to show // default 30 days
// hasButtons?: boolean,
// icon?: boolean,
// type: "DAYS_VALIDATION" | "BOOLEAN_VALIDATION" | "UNNAUTHENTICATE_VALIDATION"   // type of variable value saved.

export const communications = [
  {
    id: 1,
    title: 'AVISO',
    children: <BenefitsContent />,
    paths: ['/tramites-conectividad', '/tramites-de-autorizaciones'],
    variable: 'advice-benefits',
    acceptCircle: false,
    fromDate: '',
    toDate: '08-04-2024', // DD-MM-YYYY
    type: types.BOOLEAN_VALIDATION,
    icon: true,
  },
  {
    id: 2,
    title: '¡Mejorar la experiencia es un trabajo en equipo!',
    children: <PrestationWithCode />,
    paths: ['/tramites-de-autorizaciones'],
    variable: 'prestation-code',
    acceptCircle: false,
    fromDate: '01-06-2024', // DD-MM-YYYY
    toDate: '31-12-2024', // DD-MM-YYYY
    each: 30, // days to show
    hasButtons: true,
    type: types.DAYS_VALIDATION,
    icon: true,
  },
  {
    id: 3,
    title: 'Información importante',
    children: <MigrationContent />,
    paths: ['/'],
    fromDate: '13-06-2025',
    toDate: '20-06-2025', // DD-MM-YYYY
    type: types.UNNAUTHENTICATE_VALIDATION,
    icon: false,
  },
];
